import { render, staticRenderFns } from "./courseType.vue?vue&type=template&id=57406fde&scoped=true"
import script from "./courseType.vue?vue&type=script&lang=ts"
export * from "./courseType.vue?vue&type=script&lang=ts"
import style0 from "./courseType.vue?vue&type=style&index=0&id=57406fde&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57406fde",
  null
  
)

export default component.exports